// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-msg[data-v-38504744]{text-align:center;padding:2rem 0}.loading-msg .spinner[data-v-38504744]{color:#9b9b9b;width:30px;height:30px;margin-right:6px}.loading-msg .message[data-v-38504744]{color:#333;font-size:1.4rem;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
